<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class ProductList extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'keyword',
      label: '产品',
      form: {
        component: 'input',
        props: {
          placeholder: '名称/货号搜索'
        }
      }
    }
  ]

  table = {
    data: []
  };

  columns = [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'name',
      label: '产品标题',
      minWidth: 150,
      renderCell(h, { row }) {
        return (
          <c-router-link to={{ name: 'products.show', params: { id: row.product_id } }}>
            <el-button type="text">{ row.name }</el-button>
          </c-router-link>
        )
      }
    },
    {
      prop: 'cover',
      label: '图片',
      renderCell: 'image'
    },
    {
      prop: 'sale_price_range',
      label: '单价（元）',
    },
    {
      prop: 'position',
      label: '权重'
    },
    {
      prop: 'enabled',
      label: '已上架',
      renderCell: 'bool'
    },
    {
      prop: 'published_at',
      label: '首次上架时间',
      renderCell: 'time'
    },
    _.merge({
      prop: 'action',
      label: '操作',
      fixed: 'right',
      width: 200,
      extraAction: (h, { row }) => {
        const updatePosition = async() => {
          let position = await this.$prompt('权重(从小到大排序)', '修改产品权重', {
            inputValue: row.position,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /^[0-9]*$/,
            inputErrorMessage: '格式不正确'
          });
          position = position.value;
          await this.$request.put(`/color_products/${row.id}`, { position: position });
          this.$message.success('操作成功');
          this.fetchData();
        }

        return [
          {
            text: '修改权重',
            handler: updatePosition,
            permission: 'color_products.update'
          }
        ];
      }
    }, {})
  ]

  async mounted() {
    this.fetchData();
  }

  async fetchData() {
    const result = await this.$request.get(`/tab_modules/${this.$route.params.id}/color_products`, { params: this.$route.query });
    this.table.data = result.data;
    this.pagination = result.pagination;
  }
}

</script>
